module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Agenda.6f850a76-ps.jpg";